<nz-select
  class="w_100"
  [ngModel]="getCombinedValue(filter)"
  nzPlaceHolder="Select field"
  (ngModelChange)="onCombinedFieldSelection($event, filter)"
  nzAllowClear
  [nzDropdownRender]="customDropdownTemplate"
  [nzNotFoundContent]="''"
  [nzShowSearch]="false"
>
  <nz-option
    *ngIf="getCombinedValue(filter)"
    [nzLabel]="getCombinedValue(filter)"
    [nzValue]="getCombinedValue(filter)"
    nzHide
  >
  </nz-option>
</nz-select>

<!-- Your existing custom dropdown template -->
<ng-template #customDropdownTemplate>
  <!-- Search input -->
  <div style="padding: 8px; border-bottom: 1px solid #f0f0f0">
    <input
      #searchInput
      nz-input
      placeholder="Search fields..."
      [(ngModel)]="searchTerm"
      (input)="onSearchChange($event)"
      style="width: 100%"
    />
  </div>

  <!-- Dropdown content -->
  <div style="max-height: 200px; overflow-y: auto">
    <!-- Main Entity Group -->
    <div *ngIf="shouldShowEntity(default_data?.entity?.display_name)">
      <div class="entity-header">{{ default_data?.entity?.display_name }}</div>

      <!-- Priority fields -->
      <div
        *ngFor="let field of getFilteredMainEntityPriorityFields()"
        class="field-option priority-field"
        (click)="
          selectFieldWithFilter(
            default_data?.entity?.name,
            field.name,
            field.label,
            filter
          )
        "
        [class.selected]="
          isSelected(default_data?.entity?.name, field.name, filter)
        "
      >
        <span class="star">★</span> {{ field.label }}
      </div>

      <!-- Non-priority fields (when expanded) -->
      <div *ngIf="expandedEntities[default_data?.entity?.name]">
        <div
          *ngFor="let field of getFilteredMainEntityNonPriorityFields()"
          class="field-option"
          (click)="
            selectFieldWithFilter(
              default_data?.entity?.name,
              field.name,
              field.label,
              filter
            )
          "
          [class.selected]="
            isSelected(default_data?.entity?.name, field.name, filter)
          "
        >
          {{ field.label }}
        </div>
      </div>

      <!-- More/Less button for non-priority fields -->
      <div
        *ngIf="getFilteredMainEntityNonPriorityFields().length > 0"
        class="expand-option"
        (click)="toggleEntityExpansion(default_data?.entity?.name)"
      >
        <span *ngIf="!expandedEntities[default_data?.entity?.name]">
          + {{ getFilteredMainEntityNonPriorityFields().length }} more fields
        </span>
        <span *ngIf="expandedEntities[default_data?.entity?.name]">
          - Show less
        </span>
      </div>
    </div>

    <!-- Child Entity Groups -->
    <div *ngFor="let childData of default_data?.child_data">
      <div *ngIf="!childData.default && shouldShowEntity(childData.label)">
        <div class="entity-header">{{ childData.label }}</div>

        <!-- Priority fields for child entity -->
        <div
          *ngFor="
            let field of getFilteredChildEntityPriorityFields(
              childData.entity_name
            )
          "
          class="field-option priority-field"
          (click)="
            selectFieldWithFilter(
              childData.field_name,
              field.name,
              field.label,
              filter
            )
          "
          [class.selected]="
            isSelected(childData.field_name, field.name, filter)
          "
        >
          <span class="star">★</span> {{ field.label }}
        </div>

        <!-- Non-priority fields for child entity (when expanded) -->
        <div *ngIf="expandedEntities[childData.field_name]">
          <div
            *ngFor="
              let field of getFilteredChildEntityNonPriorityFields(
                childData.entity_name
              )
            "
            class="field-option"
            (click)="
              selectFieldWithFilter(
                childData.field_name,
                field.name,
                field.label,
                filter
              )
            "
            [class.selected]="
              isSelected(childData.field_name, field.name, filter)
            "
          >
            {{ field.label }}
          </div>
        </div>

        <!-- More/Less button for child entity -->
        <div
          *ngIf="
            getFilteredChildEntityNonPriorityFields(childData.entity_name)
              .length > 0
          "
          class="expand-option"
          (click)="toggleEntityExpansion(childData.field_name)"
        >
          <span *ngIf="!expandedEntities[childData.field_name]">
            +
            {{
              getFilteredChildEntityNonPriorityFields(childData.entity_name)
                .length
            }}
            more fields
          </span>
          <span *ngIf="expandedEntities[childData.field_name]">
            - Show less
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
